import { FunctionComponent } from "react"
import { Button, Form, InputGroup } from "react-bootstrap"

interface IFilterField {
	filter: string
	setFilter: (v: string) => void
	placeholder: string
}
const FilterField: FunctionComponent<IFilterField> = ({ filter, setFilter, placeholder }) => {
	return (
		<InputGroup>
			<Form.Control
				type="text"
				size="sm"
				placeholder={placeholder}
				value={filter}
				onChange={(e) => setFilter(e.target.value)}
			/>
			{filter && (
				<Button variant="outline-secondary" size="sm" onClick={() => setFilter("")}>
					Clear
				</Button>
			)}
		</InputGroup>
	)
}
export default FilterField
